const url = {
    production: 'https://agction.astra.co.id/agctionapi/api/v1',
    staging: 'https://devagc.astra.co.id/apiagc/api/v1',
    development: 'http://localhost:5000/astra/api/v1'
};

const url_public = {
    production: 'https://agction.astra.co.id/agctionapi',
    staging: 'https://devagc.astra.co.id/apiagc',
    development: 'http://localhost:5000/astra'
};

const ENV = process.env.REACT_APP_BUILD_ENV || 'development';

export const BASE_API = url[ENV];

export const BASE_URL = url_public[ENV];

// Duende IdentityServer Configuration
const duende_url = {
    production: process.env.REACT_APP_DUENDE_URL || 'https://accounts.astra.co.id',
    staging: process.env.REACT_APP_DUENDE_URL || 'https://stg-accounts.astra.co.id',
    development: process.env.REACT_APP_DUENDE_URL || 'https://stg-accounts.astra.co.id'
}

// Base domain used for Duende redirect & post-logout redirect.
const redirect_base = {
    production: 'https://agction.astra.co.id',
    staging: 'https://devagc.astra.co.id',
    development: 'https://devagc.astra.co.id'
};

const REDIRECT_BASE_OVERRIDE = process.env.REACT_APP_DUENDE_REDIRECT_BASE;
const EFFECTIVE_REDIRECT_BASE = REDIRECT_BASE_OVERRIDE || redirect_base[ENV];

export const DUENDE_CONFIG = {
    BASE_URL: duende_url[ENV],
    CLIENT_ID: process.env.REACT_APP_DUENDE_CLIENT_ID || 'c83bb9ba-ad0e-434d-b27a-5155917d186e',
    CLIENT_SECRET: process.env.REACT_APP_DUENDE_CLIENT_SECRET || 'JpKWE8SCRyLYnYSpbTMU',
    REDIRECT_URI: EFFECTIVE_REDIRECT_BASE + '/astra/#/oauth/callback',
    POST_LOGOUT_REDIRECT_URI: EFFECTIVE_REDIRECT_BASE + '/astra/#/login',
    SCOPE: 'openid offline_access verification profile',
    RESPONSE_TYPE: 'code',
};

export const COLOR = {
    primary: '#006aaf',
    secondary: '#f39c12',
    emas: '#fec107',
    hijau: '#00af00',
    biru: '#03a9f3',
    merah: '#fe1313',
    hitam: '#454545',
    abu: '#A2A2A2',
    ungu: '#ab8ce4'
};

export const ROLE = {
    ADMIN_PUSAT: 1,
    ADMIN_PERUSAHAAN: 2,
    PIMPINAN_INSTALASI: 3,
    MANAGEMENT_ASTRA: 4,
    PIC_INSTALASI: 5,
    ASESSOR: 6,
    KEPALA_PERUSAHAAN: 7
};

export const jenisPerusahaan7Aspek = [11, 12, 13, 14];

export const FILTER_PERTANYAAN = {
    SUDAH_DIISI: 1,
    BELUM_DIISI: 2,
    SEMUA: 3
};

export const FILTER_CONFIRM = {
    SUDAH_CONFIRM: 1,
    BELUM_CONFIRM: 2,
    SEMUA: 3
};

export const urlAstraI = 'https://agction.id/assets/img/astra-international.png';
export const urlAstraGC = 'https://agction.id/assets/img/green-company.jpg';
export const conformityfrac = 'https://agction.id/assets/img/conformityfrac.png';
export const actionqrcode = 'https://agction.id/assets/img/agction-qrcode.png';
// export const conformityfrac = 'http://localhost:3000/assets/img/conformityfrac.png' //mode development
// export const actionqrcode = 'http://localhost:3000/assets/img/agction-qrcode.png' //mode development
export const MASTER_SHEET = {
    AGC_CONFORMITY: 1,
    CP_LINGKUNGAN: 2,
    CP_SAFETY: 3,
    LEGAL_COM: 4,
    FRSR: 5,
    EFISIEN_ENERGI: 6,
    ECO_LIMBAH_B3: 7,
    ECO_LIMBAH_NONB3: 8,
    ECO_CEMAR_UDARA: 9,
    KONSERVASI_AIR: 10,
    ANEKA_HAYATI: 11,
    CD: 12,
    TKTF: 13
};

export const STAGE = {
    DRAFT: 0,
    ONE_AUDIT: 1,
    ONE_NON_CONFORMITY: 2,
    TWO_AUDIT: 3
};

export const STAGE_ASSESSMENT = {
    PENGISIAN: 0,
    AUDIT: 1,
    FINAL: 2,
    EXCEPTION: 3,
}

export const SYNCHRONIZE_STATUS = {
    FIRST: 0,
    PROCESS: 1,
    DONE: 2
}
